import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJuisciMainAvatar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_519_6192)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.5 32.5C25.3366 32.5 32.5 25.3366 32.5 16.5C32.5 7.66344 25.3366 0.5 16.5 0.5C7.66344 0.5 0.5 7.66344 0.5 16.5C0.5 25.3366 7.66344 32.5 16.5 32.5Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.4554 23.916C16.2531 23.916 16.0886 23.7514 16.0886 23.5491V5.71257C16.0886 5.61543 16.1274 5.52172 16.196 5.45315L18.2223 3.42686C18.3651 3.284 18.5971 3.284 18.7411 3.42686C18.8851 3.56972 18.884 3.80172 18.7411 3.94572L16.8223 5.86457V23.5503C16.8223 23.7526 16.6577 23.9171 16.4554 23.9171V23.916Z",
				fill: "#212121"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.012 27.3343C13.6074 27.3343 13.2783 27.0063 13.2783 26.6006V10.5892C13.2783 10.1846 13.6063 9.85544 14.012 9.85544C14.4177 9.85544 14.7457 10.1834 14.7457 10.5892V26.6017C14.7457 27.0063 14.4177 27.3354 14.012 27.3354V27.3343Z",
				fill: "#212121"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.988 27.3343C18.5834 27.3343 18.2543 27.0063 18.2543 26.6006V10.5892C18.2543 10.1846 18.5823 9.85544 18.988 9.85544C19.3937 9.85544 19.7217 10.1834 19.7217 10.5892V26.6017C19.7217 27.0063 19.3937 27.3354 18.988 27.3354V27.3343Z",
				fill: "#212121"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.5 29.8223C14.724 29.8223 13.2794 28.3777 13.2794 26.6017C13.2794 26.1972 13.6074 25.868 14.0131 25.868C14.4188 25.868 14.7468 26.196 14.7468 26.6017C14.7468 27.5686 15.5343 28.356 16.5011 28.356C17.468 28.356 18.2554 27.5686 18.2554 26.6017C18.2554 26.1972 18.5834 25.868 18.9891 25.868C19.3948 25.868 19.7228 26.196 19.7228 26.6017C19.7228 28.3777 18.2783 29.8223 16.5023 29.8223H16.5Z",
				fill: "#212121"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.2543 15.756V26.5937C18.2543 27.5617 17.4657 28.3491 16.4988 28.3491C15.532 28.3491 14.7468 27.5606 14.7468 26.5937V15.756H18.2554H18.2543Z",
				fill: "#FFC408"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_519_6192",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white",
			transform: "translate(0.5 0.5)"
		})
	}) })]
});
export default SvgJuisciMainAvatar;
